// extracted by mini-css-extract-plugin
export var addButton = "_i7-0";
export var border = "_i7-8";
export var check = "_i7-h";
export var danger = "_i7-6";
export var dropdownContainer = "_i7-1";
export var editModalBody = "_i7-j";
export var footerContainer = "_i7-i";
export var fullWidth = "_i7-a";
export var hide = "_i7-9";
export var icon = "_i7-3";
export var input = "_i7-7";
export var inputFlex = "_i7-b";
export var inputWrapper = "_i7-c";
export var manualFocus = "_i7-5";
export var optionButton = "_i7-4";
export var pillWrapper = "_i7-e";
export var pointer = "_i7-2";
export var showOverflow = "_i7-f";
export var tagsFlex = "_i7-d";
export var xButton = "_i7-g";